import { render, staticRenderFns } from "./BaseFooterCline.vue?vue&type=template&id=3274dfee&scoped=true&"
import script from "./BaseFooterCline.vue?vue&type=script&lang=js&"
export * from "./BaseFooterCline.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooterCline.vue?vue&type=style&index=0&id=3274dfee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_e0fc12eb4d0f55f4cb07c19882e21395/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3274dfee",
  null
  
)

export default component.exports